// @flow
import React, { type Element } from 'react';
import { connect } from 'react-redux';
import { analytics, analyticsActions, Track } from 'angieslist-app-platform';
import { Image } from 'angieslist-react-components';
import { compose, pure } from 'recompose';
import { ChevronRightIcon16 } from '@angi/icons/design-system-icons/ui-icons/16';
import './serviceAreaUpsellComponent.scss';
import DesktopCustomer from '../../../setup/browser/assets/upgrade_image_mobile.png';
import serviceAreaMapAnalytics from '../../../../app/browser/service-areas/serviceAreaMapAnalytics';

type Props = {
  titleFirstLine: string,
  titleSecondLine: string,
  subtitle1: string,
  subtitle2: string,
  learnMoreLink: string,
}


export const ServiceAreaPremiumUpsellCard = (props: Props) : Element<"div"> => {
  const {
    titleFirstLine,
    titleSecondLine,
    subtitle1,
    subtitle2,
    learnMoreLink,
  } = props;
  const handleClick: (() => void) = () => { window.location.href = learnMoreLink; };

  return (
    <Track>
      <div id="service-area-upsell-card">
        <div
          id="service-area-upsell-card-container"
          onClick={handleClick}
          onKeyDown={handleClick}
          role="button"
          tabIndex={0}
        >
          <div id="premiem-upsell-card-text-container">
            <div id="service-area-upsell-card-title-container" className="National2-Bold">
              <span className="premium-upsell-title-white-text">{titleFirstLine} </span>
              <span className="premium-upsell-title-green-text">{titleSecondLine}</span>
            </div>
            <div id="service-area-upsell-card-subtitle1-container" className="National2-Regular">
              {subtitle1}
            </div>
            <div id="service-area-upsell-card-subtitle2-container" className="National2-Medium">
              {subtitle2}
              <div id="premium-upsell-subtitle2-chevron-container">
                <ChevronRightIcon16 />
              </div>
            </div>
          </div>
          <div id="premiem-upsell-card-image-container">
            <Image
              id="premium-upsell--background-image"
              src={DesktopCustomer}
            />
          </div>
        </div>
      </div>
    </Track>
  );
};


export default (compose(
  connect(analyticsActions),
  analytics({
    ruleset: serviceAreaMapAnalytics,
  }),
  pure,
)(ServiceAreaPremiumUpsellCard): any);



// WEBPACK FOOTER //
// ./src/modules/home/browser/components/serviceAreaUpsellComponent.js